export const numberUtilityMixin = {
  methods: {
    formatWithCommas(value) {
      const num = value || 0;
      let numWithCommas = "";
      const regexp = /\B(?=(\d{3})+(?!\d))/g;
      const sanitizedNum = typeof num === "string" ? num.replace(",", "") : num;

      numWithCommas = sanitizedNum.toString().replace(regexp, ",");

      return numWithCommas;
    },

    formatMoney(value, forStripe = true) {
      // stripe returns full decimal strings with no decimal, ie "1000" = 10.00
      const money = forStripe ? value * 0.01 : value;

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(money);
    },

    sanitizeNum(num) {
      return parseInt(String(num).replace(/\D/, ""), 10);
    }
  }
};
